<template>
  <div class="google-autocomplete">
    <input
      :id="inputElement.id"
      :placeholder="inputElement.placeholder"
      :disabled="inputElement.disabled"
      :value="inputElement.preValue"
      @input="$emit('input-changed', $event)"
    >
  </div>
</template>

<script>
import { googleMapInit } from '../../../../services/googleMapService'

export default {
  props: {
    inputElement: {
      type: Object,
      required: true
    }
  },

  async mounted() {
    try {
      const google = await googleMapInit()
      const autoService = new google.maps.places.Autocomplete(
        document.getElementById(this.inputElement.id),
        { componentRestrictions: { country: 'us' } }
      )

      autoService.addListener('place_changed', () => {
        const googlePlace = autoService.getPlace()
        let isGoogleLocation = false
        let latitude = null
        let longitude = null

        if (googlePlace.geometry && googlePlace.geometry.location) {
          latitude = googlePlace.geometry.location.lat()
          longitude = googlePlace.geometry.location.lng()
          isGoogleLocation = true
        }

        let selectedPlace = {
          Address: googlePlace.formatted_address,
          arrivalTime: null,
          latitude,
          longitude,
          propertyId: null
        }
        const type = this.inputElement.id === 'startBox' ? 'start' : 'end'
        this.$emit('google-location-selected', { type, isGoogleLocation, selectedPlace })
      })
    } catch (error) {
      console.log(error)
    }
  }
}
</script>

<style lang="sass">
.pac-container
  min-width: 45rem !important
  .pac-item
    padding: 0.5rem
</style>

<style lang="sass" scoped>
.google-autocomplete
  margin-top: 18px
  margin-bottom: 20px

#startBox, #endBox
  width: 100%
  padding: 8px 0
  line-height: 20px
  font-size: 16px
  border-bottom: 1px solid $hwayzShadow
</style>
